import React from 'react';
import { store } from 'react-notifications-component';
import { handleNullException } from '../../services/UtilsService';
import ErrorFlag from './ErrorFlag';
import SuccessFlag from './SuccessFlag';

const defaultErrorMessage = 'Unfortunately, it fails pls try again later';
const defaultSuccessMessage = 'Success';

export const addToastForAPIResponse = (type: 'success' | 'error' | undefined, message?: string) => {
  store.addNotification({
    insert: 'top',
    container: 'top-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: type?.toLowerCase() === 'error' ? 8000 : 3000,
    },
    content:
      type?.toLowerCase() === 'error' ? (
        <ErrorFlag title={message || defaultErrorMessage} />
      ) : (
        <SuccessFlag title={message || defaultSuccessMessage} />
      ),
  });
};
//  eslint-disable-next-line
export const apiErrorToast = (error: any) => {
  const errorMessage =
    handleNullException(error, 'response.data.message') || handleNullException(error, 'response.data.error');
  return errorMessage ? addToastForAPIResponse('error', errorMessage.toString()) : addToastForAPIResponse('error');
};

export default {
  apiErrorToast,
  addToastForAPIResponse,
};
